import { router } from 'src/main';
import { type appConfigType, type appPermissions } from 'shared/platforms/platformTypes';

// @ts-expect-error somehow this isnt properly loaded, it does work
import { config } from '@platform/config';
export const appConfig: appConfigType = config;

export function isRouteAllowed(...requiredPermissions: (keyof appPermissions)[]) {
	const isAllowed = requiredPermissions.every((p) => appConfig.permissions[p]);

	if (!isAllowed) {
		console.warn('Platform does not have permissions to access this page');
		router.history.back();
	}
}
